import React from 'react';
import { Link } from 'react-router-dom';
import { Brain } from 'lucide-react';

export const Footer = () => {
  return (
    <footer 
      className="py-8 mt-auto" 
      style={{ 
        background: 'var(--card-bg)', 
        borderTop: '1px solid var(--card-border)' 
      }}
      data-testid="app-footer"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          {/* Brand */}
          <div className="flex items-center">
            <img 
              src="/logo-64.png" 
              alt="HearMeOut Logo" 
              className="h-9 object-contain -mr-0.5"
            />
            <span className="font-bold text-sunrise-black" style={{ fontFamily: 'Nunito, sans-serif' }}>
              HearMeOut
            </span>
          </div>

          {/* Links */}
          <div className="flex items-center gap-6">
            <Link 
              to="/about" 
              className="text-sunrise-medium hover:text-sunrise-black transition-colors text-sm"
              data-testid="footer-about-link"
            >
              About Us
            </Link>
            <Link 
              to="/contact" 
              className="text-sunrise-medium hover:text-sunrise-black transition-colors text-sm"
              data-testid="footer-contact-link"
            >
              Contact Us
            </Link>
          </div>

          {/* Copyright */}
          <div className="text-sunrise-light text-sm">
            © {new Date().getFullYear()} HearMeOut. All rights reserved.
          </div>
        </div>

        {/* Disclaimer */}
        <div className="mt-6 pt-6 text-center" style={{ borderTop: '1px solid var(--card-border)' }}>
          <p className="text-xs text-sunrise-light max-w-2xl mx-auto">
            HearMeOut is not a replacement for professional mental health care. 
            If you are in crisis, please contact emergency services or a qualified healthcare professional.
          </p>
        </div>
      </div>
    </footer>
  );
};
